module.exports = __webpack_public_path__ + "static/media/1.f3c61665.jpg";